import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

const getAssetId = async (name: string) => {
  const { data, error } = await supabase
    .from('asset_stats')
    .select('*')
    .eq('name', name)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetAssetStatsVideo() {
  return useMutation((name: string) => getAssetId(name), {
    onSuccess: async (res) => res,
  })
}
